import React from 'react'
import PropTypes from 'prop-types'
import Typography from '../Typography'
import classes from './appointment-location-info.module.sass'
import locationIcon from './Location_Icon.png';

const AppointmentLocationInfo = ({ school }) => {
  if (!school) return null

  return (
    <div>
      <Typography tag="div" weight="bold" classes={classes.grayWarning}>
        <img className={classes.icon} src={locationIcon} />
        <div>
          <Typography weight="bold" classes={classes.locationHeader}>Location:</Typography>
          <span>Pictures will be taken at</span>
          <Typography weight="bold" classes={classes.location}>{school.scheduleLocation}</Typography>
        </div>
      </Typography>
    </div>
  )
}

AppointmentLocationInfo.propTypes = {
  school: PropTypes.object,
}

export default AppointmentLocationInfo
